import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SiteMapComponent} from './site-map.component';
import {ApplicationPipesModule} from "../application-pipes-module/application-pipes.module";
import {ReactiveFormsModule} from "@angular/forms";

@NgModule({
  imports: [
    CommonModule,
    ApplicationPipesModule,
    ReactiveFormsModule,
  ],
  declarations: [SiteMapComponent],
  exports: [SiteMapComponent]
})
export class SiteMapModule {
}
